export default "__VITE_ASSET__DpG$$Ogv__"